import { FormInstance } from 'antd'
import FormValues from '../types/form-values'
import { StrapiCreate } from '../../../../../../../../types/strapi/strapi'
import { stampShapes } from '../constants/constants'
import { useGetRollersQuery } from '../../../../../../../../store/api/rollers-api'
import Stamp from '../../../../../../../../types/api/stamp'
import { useGetTubesQuery } from '../../../../../../../../store/api/tubes-api'

export default function useExtractCreateStampMutationArg(
    form: FormInstance<FormValues>
): () => StrapiCreate<Stamp> {
    const { data: list } = useGetRollersQuery()
    const tubesQueryParams = {
        filters: {
            stamps: {
                $null: 'true',
            },
        },
        pagination: { pageSize: 1, page: 1 },
    }

    useGetTubesQuery(tubesQueryParams)

    return () => {
        const data: FormValues = form.getFieldsValue()
        const stampShapesIsNumber = stampShapes.findIndex(x => data.shape === x) + 1
        const roller = list?.data.find(x => x.documentId === data.roller)

        // const tubeFist = tubes?.data[0].documentId ?? ''
        // const tube = !data.tube || data.tube === '' ? tubeFist : data.tube

        return {
            data: {
                // uuid: string
                number: data.number,
                length: data.length,
                width: data.width,
                quantity: data.quantity,
                floods: data.floods,
                roller: { set: [data.roller] },
                range: data.range,
                code: `${data.width}${data.length}${roller?.roller}${stampShapesIsNumber}`,
                shape: data.shape,
                comment: data.comment || '',
                locked: data.locked,
                imageLink: data.imageLink,
                layoutLink: data.layoutLink,
                contractor: { set: [data.contractor] },
                tube: data.tube ? { set: [data.tube] } : undefined,
                radius: data.radius,
                material_groups: { set: data.materialGroups },
                externalId: data.externalId,
                approximateCost: data.approximateCost,
            },
        }
    }
}
